import { useEffect } from "react";
import Lenis from "lenis";

const NAV = 72;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.href = `/#${id}`;
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -NAV, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const sectionTarget = (dir) => {
  const vh = window.innerHeight;
  const y = window.scrollY;
  const els = Array.from(document.querySelectorAll("main > section, footer"));
  const rects = els.map((el) => el.getBoundingClientRect());
  const idx = Math.max(0, rects.findIndex((r) => r.top <= NAV + 2 && r.bottom > NAV + 2));
  const cur = rects[idx];
  if (dir > 0) {
    if (cur.bottom > vh + 4) return y + Math.min(vh * 0.85, cur.bottom - vh);
    const next = rects[idx + 1];
    return next ? y + next.top - NAV : null;
  }
  if (cur.top < NAV - 4) return y + Math.max(-vh * 0.85, cur.top - NAV);
  const prev = rects[idx - 1];
  if (!prev) return null;
  return prev.height > vh - NAV ? y + prev.bottom - vh : y + prev.top - NAV;
};

export const SmoothScroll = () => {
  useEffect(() => {
    const snap = window.matchMedia("(pointer: fine) and (min-width: 1024px)").matches;
    const lenis = new Lenis({ duration: 1.25, smoothWheel: !snap, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    window.__lenis = lenis;
    let raf;
    let busy = false;
    let cooldown;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onWheel = (e) => {
      if (e.ctrlKey || Math.abs(e.deltaY) < 4) return;
      e.preventDefault();
      if (busy) return;
      const target = sectionTarget(Math.sign(e.deltaY));
      if (target == null) return;
      busy = true;
      lenis.scrollTo(target, {
        duration: 1.1,
        onComplete: () => {
          cooldown = setTimeout(() => {
            busy = false;
          }, 450);
        },
      });
    };
    if (snap) window.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", onWheel);
      clearTimeout(cooldown);
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};
